<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生产数据异常查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="交货单" prop="outBillCode">
                <el-input v-model="searchform.outBillCode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
           
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['deliveryorder_select']">搜索</el-button>
              <!-- <el-button
              v-permission="['deliveryorder_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>生产数据异常查询</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="freight_bill_code" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="out_bill_code" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
           
            <el-table-column prop="from_warehouse" label="发货仓库" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer_name" label="客户" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="箱码" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batch_no" label="出库批次" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <!-- <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findqrcodenotinworkorder } from "@/api/physical";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    // this.Tabledata();

  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      channelType:[
        {
          value:0,
          label:"配送中心"
        },
        {
          value:1,
          label:"退货仓"
        }
      ],
      packageLevel:[
        {
          value:1,
          label:"盒"
        },
        {
          value:2,
          label:"箱"
        }
      ],
      searchform: {
        outBillCode:null,
        datelist:[],// 接收时间数组，暂不调用
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findqrcodenotinworkorder(obj).then(response => {
        this.tableData = response.data;
        this.packdate(this.tableData);
        this.currentPage = response.data.currPage;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    // 拼装列表数据
        packdate(obj){
          for (let i = 0; i < obj.length; i++) {
         obj[i].from_warehouse = (obj[i].from_warehouse_code || " ") +  (obj[i].from_warehouse || " ");
         obj[i].dealer_name =   (obj[i].dealer_code || " ") + (obj[i].dealer_name || " ");
         obj[i].product = (obj[i].product_code || ' ' ) + (obj[i].product_name || ' ' );
         switch (obj[i].status) {
           case 0: obj[i].status = "未发货"            
             break;
             case 1: obj[i].status = "已发货"            
             break;
             case 2: obj[i].status = "已签收"            
             break;        
           default:
             break;
         };
        }
        },
    //搜索事件
    search() {
        this.Tabledata({
          outBillCode:this.searchform.outBillCode,
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
        outBillCode:this.searchform.outBillCode,
        currPage:this.searchform.currPage,
        pageSize:this.searchform.pageSize
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
     this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
         outBillCode:this.searchform.outBillCode,
      };
      selectoutbillorderqrcode(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.packdate(this.tableDataDownload);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "运单号",
            "出库单号",
            "发货仓库",
            "客户",
            "产品",
            "箱码",
            "出库批次",
          ];
          const filterVal = [
            "freight_bill_code",
            "out_bill_code",
            "from_warehouse",
            "dealer_name",
            "product",
            "qrcode",
            "batch_no",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>